import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    Box,
    Tabs,
    Tab,
    TableContainer,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import CreditForm from './CreditForm';
import DebitForm from './DebitForm';
import { AddCircle, Refresh, DeleteRounded, ArrowBackIosRounded, ArrowBackRounded, Restore, AssignmentReturn, AssignmentReturned, KeyboardReturnOutlined } from '@mui/icons-material';
import CreditDetails from './CreditDetails';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import { SearchBarV2 } from '../../common/SearchBar';
import DebitsList from './DebitsList';
import { SingleCheckbox } from '../../common/RadioAndCheckbox';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class CreditsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        openForm: false,
        openDetails: false,
        credit: {},
        debit: false,
        searchCredit: "",
        available: true,
        tabIndex: 0,
    }

    handleChange = (e) => {
        this.setState({ searchCredit: e.target.value });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    
    componentDidMount = () => {
        // Vérifier si le paramètre credit_id est présent dans l'URL
        const params = new URLSearchParams(window.location.search);
        const creditId = params.get('credit_id');
        
        if (creditId) {
            this.openCreditDetailsFromUrl(creditId);
        }
    }
    
    componentDidUpdate = (prevProps) => {
        // Si les credits viennent d'être chargés et qu'on attendait un credit_id de l'URL
        const params = new URLSearchParams(window.location.search);
        const creditId = params.get('credit_id');
        
        // Ne vérifier que si on n'a pas encore ouvert la boîte de dialogue
        if (creditId && !this.state.openDetails) {
            const { CREDITS } = this.props;
            // Vérifier si les CREDITS sont maintenant disponibles et contiennent le credit_id recherché
            if (!isEmpty(CREDITS) && CREDITS[creditId]) {
                // Vérifier si les CREDITS viennent d'être chargés ou si on n'avait pas encore essayé
                if (isEmpty(prevProps.CREDITS) || !prevProps.CREDITS[creditId]) {
                    this.openCreditDetailsFromUrl(creditId);
                }
            }
        }
    }
    
    openCreditDetailsFromUrl = (creditId) => {
        const { CREDITS } = this.props;
        
        // Attendre que les credits soient chargés
        if (!isEmpty(CREDITS) && CREDITS[creditId]) {
            const selectedCredit = CREDITS[creditId];
            this.setState({ 
                openDetails: true, 
                credit: selectedCredit 
            });
            
            // Nettoyer l'URL pour retirer le paramètre après ouverture de la modale
            const newUrl = window.location.pathname;
            window.history.replaceState({}, '', newUrl);
        }
    }

    getFilteredList = () => {
        const { USERS, CREDITS } = this.props;
        const { searchCredit, available } = this.state;
        let list = Object.values(CREDITS)
        // users
        console.log('====================================');
        console.log({searchCredit});
        console.log('====================================');
        if(!isEmpty(searchCredit)){
            list = list.filter( item => (
                item.credit_ref.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].username.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].email.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].lastname.toLowerCase().includes(searchCredit.toLowerCase())
            ))
        }
        if(available){
            list = list.filter( item => item.credit_available)
        }

        return list
    }

    displayList = () => {
        const { CREDITS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(CREDITS)){
            let all = this.getFilteredList()            
            rows = size(all)
            console.log('====================================');
            console.log({all, rows});
            console.log('====================================');
            tab.push(this.getCreditList(all))
        }
        return {tab, rows}
    }


    getCreditList = (list) => {
        const { CREDITS, USERS, BANKS } = this.props
        const { rowsPerPage, page } = this.state;

        if (!isEmpty(CREDITS) && !isEmpty(USERS) && !isEmpty(BANKS) ){
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                let background = item.credit_op === "DEBIT" ? "#e48a88b3" : "light-blue"
                return (
                    <TableRow hover key={item.credit_id} className="clickable" style={{ background }}
                           
                        title="Voir le Détail"
                    >
                        {/* <th scope="row">{item.user}</th> */}
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {new Date(item.credit_creation_date).toLocaleString('fr-FR')}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_ref}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_op === "DEBIT" && "-"}<Currency value={item.credit_amount} />
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            <b><Currency value={item.credit_total_available} /></b>
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_user_id && USERS[item.credit_user_id].username} {item.credit_user_id && USERS[item.credit_user_id].lastname}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_user_id && USERS[item.credit_user_id].email}
                        </TableCell>
                        {/* <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_op}
                        </TableCell> */}
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_bank && BANKS[item.credit_bank].bank_name}
                        </TableCell>
                        <TableCell title="Retour sur Avance" >
                            {item.credit_total_available > 0 &&
                                <IconButton 
                                    size="small" 
                                    color="primary"
                                    onClick={ () => this.setState({openReturn: true, credit: item}) }
                                >
                                    <KeyboardReturnOutlined />
                                </IconButton>
                            } 
                        </TableCell> 
                        <TableCell>
                            {item.credit_total_available === item.credit_amount && item.credit_op != "DEBIT" &&
                                <IconButton 
                                    size="small" 
                                    color="secondary"
                                    onClick={ () => this.setState({openDelete: true, selected: item}) }
                                >
                                    <DeleteRounded />
                                </IconButton> 
                            }     
                        </TableCell>      
                    </TableRow>
                )
            })
        }
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openDelete: false,
            credit: {},
            openForm: false,
            debit: false,
        });
    };    

    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteCredit(selected)
        if(this.props.STATE.credits.error){
            this.props.notif("error", this.props.STATE.credits.error)
        } else {
            this.props.notif("success", "Avance supprimée")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
        
    render() {
        const { CREDITS } = this.props;
        const { rowsPerPage, page, openForm, openReturn, openDetails, credit, openDelete, selected, tabIndex } = this.state;
        console.log('==== STATE CREDIT LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let data = this.displayList()
        return (
            <div>
                {openForm &&
                    <CreditForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openReturn && !isEmpty(credit) &&
                    <DebitForm open={openReturn} handleClose={this.handleClose} {...this.props} {...credit} />
                }
                {openDetails && !isEmpty(credit) && 
                    <CreditDetails open={openDetails} handleClose={this.handleClose} {...this.props} credit={credit} />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"l'avance"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.credits.fetching}
                    >
                        Avance du {new Date(selected.credit_creation_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.credit_amount} />
                    </DeleteDialog>
                }

                <TitleWithEndAction
                    title={""}
                    disabled={this.props.downloading}
                >
                    <div>
                        {this.props.isSuper &&
                            <IconButton color="primary" onClick={this.props.recalcCredits}>
                                <Refresh />  {/* recalc all user account amount */}
                            </IconButton>
                        }
                    </div>
                </TitleWithEndAction>
                <SearchBarV2
                    handleChange={this.handleChange} 
                    label="Rechercher"
                    searchValue={this.state.searchCredit}
                />
                <Box p={1}>
                    <SingleCheckbox
                        label="Avance en cours seulement"
                        checked={this.state.available}
                        onChange={(e) => this.setState({available: e.target.checked })}
                    />
                </Box>
                <Box p={2}>
                    <TableContainer sx={{maxWidth: "100%"}}>

                    </TableContainer>
                    {!isEmpty(data.tab) && 
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Créé le</TableCell>
                                    <TableCell>Réference</TableCell>
                                    <TableCell>Montant</TableCell>
                                    <TableCell>Restant</TableCell>
                                    <TableCell>User</TableCell>
                                    <TableCell>Email</TableCell>
                                    {/* <TableCell>Type</TableCell> */}
                                    <TableCell>Banque</TableCell>
                                    <TableCell>Retour</TableCell>
                                    <TableCell>Supprimer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.tab}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={10}
                                        count={data.rows}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table> 
                    }
                </Box>
            </div>
        );
    }
}

export default CreditsList;